const Plant = () => {
  return (
    <div data-testid="sonnen-plant">
      <svg
        width="81"
        height="128"
        viewBox="0 0 81 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51.499 76.4355L45.8945 88.8057L45.415 88.5879L44.9355 88.3711L50.54 76.002L51.499 76.4355ZM52.0674 42.5273L42.5654 55.5283L42.5596 55.5234L42.7266 73.4326C42.7967 73.3684 42.8705 73.3018 42.9463 73.2324C43.6671 72.5723 44.6298 71.6899 45.5957 70.7998C46.5619 69.9094 47.531 69.0118 48.2656 68.3223C48.6331 67.9773 48.9409 67.6856 49.1592 67.4736C49.2684 67.3675 49.3527 67.2838 49.4102 67.2246C49.4392 67.1947 49.4585 67.1747 49.4688 67.1631L49.457 67.1797C49.4518 67.1873 49.4384 67.2071 49.4248 67.2344L49.8965 67.4688L50.3672 67.7031C50.3408 67.7562 50.3093 67.7965 50.2998 67.8086C50.2852 67.8272 50.2696 67.8459 50.2568 67.8604C50.231 67.8896 50.1996 67.9234 50.166 67.958C50.0977 68.0285 50.0044 68.1209 49.8926 68.2295C49.6678 68.4478 49.355 68.7438 48.9863 69.0898C48.2481 69.7828 47.2763 70.6833 46.3096 71.5742C45.3426 72.4654 44.3785 73.3483 43.6572 74.0088C43.2967 74.3389 42.9962 74.6136 42.7861 74.8057C42.7706 74.8199 42.7548 74.8334 42.7402 74.8467L42.8691 88.583L41.8164 88.5928L41.6318 68.9111L41.5752 68.9707L35.9648 63.5977L36.6934 62.8379L41.6191 67.5557L41.4121 45.3789L42.4648 45.3691L42.543 53.7744L51.2178 41.9062L52.0674 42.5273ZM35.0908 87.5977L34.7119 87.9629L34.332 88.3271L24 77.582L24.7578 76.8516L35.0908 87.5977Z"
          fill="url(#paint0_radial_8223_80777)"
        />
        <path
          d="M42.3417 127.161C63.4158 127.161 80.4997 126.435 80.4997 125.538C80.4997 124.641 63.4158 123.914 42.3417 123.914C21.2675 123.914 4.18359 124.641 4.18359 125.538C4.18359 126.435 21.2675 127.161 42.3417 127.161Z"
          fill="black"
        />
        <path
          d="M42.3417 127.161C63.4158 127.161 80.4997 126.435 80.4997 125.538C80.4997 124.641 63.4158 123.914 42.3417 123.914C21.2675 123.914 4.18359 124.641 4.18359 125.538C4.18359 126.435 21.2675 127.161 42.3417 127.161Z"
          fill="#99B3FD"
        />
        <path
          d="M61.1497 92.4258L43.6234 94.2299L26.0971 92.4258C25.6479 92.578 23.25 98.2892 23.25 98.2892L28.4838 122.769C28.7533 124.015 29.8483 124.911 31.1231 124.911H56.1238C57.3929 124.911 58.4936 124.02 58.7631 122.769L63.9969 98.2892C63.9969 98.2892 61.599 92.5724 61.1497 92.4258Z"
          fill="#008ECA"
        />
        <path
          d="M61.1497 92.4258L43.6234 94.2299L26.0971 92.4258C25.6479 92.578 23.25 98.2892 23.25 98.2892L28.4838 122.769C28.7533 124.015 29.8483 124.911 31.1231 124.911H56.1238C57.3929 124.911 58.4936 124.02 58.7631 122.769L63.9969 98.2892C63.9969 98.2892 61.599 92.5724 61.1497 92.4258Z"
          fill="url(#paint1_linear_8223_80777)"
        />
        <path
          d="M66.3929 84.9961H20.8447C18.9932 84.9961 17.4922 86.503 17.4922 88.3619V95.46C17.4922 97.3188 18.9932 98.8258 20.8447 98.8258H66.3929C68.2445 98.8258 69.7454 97.3188 69.7454 95.46V88.3619C69.7454 86.503 68.2445 84.9961 66.3929 84.9961Z"
          fill="#91D7F4"
        />
        <path
          d="M66.3929 84.9961H20.8447C18.9932 84.9961 17.4922 86.503 17.4922 88.3619V95.46C17.4922 97.3188 18.9932 98.8258 20.8447 98.8258H66.3929C68.2445 98.8258 69.7454 97.3188 69.7454 95.46V88.3619C69.7454 86.503 68.2445 84.9961 66.3929 84.9961Z"
          fill="url(#paint2_linear_8223_80777)"
        />
        <path
          d="M43.6221 20.1756C40.5111 26.6535 40.2303 33.8531 42.2856 40.6129C48.8334 38.0195 54.2749 33.3175 57.386 26.8396C60.497 20.3617 60.7778 13.1621 58.7225 6.40234C52.1747 8.99576 46.7331 13.6977 43.6221 20.1756Z"
          fill="#769E4C"
        />
        <path
          d="M43.6221 20.1756C40.5111 26.6535 40.2303 33.8531 42.2856 40.6129C48.8334 38.0195 54.2749 33.3175 57.386 26.8396C60.497 20.3617 60.7778 13.1621 58.7225 6.40234C52.1747 8.99576 46.7331 13.6977 43.6221 20.1756Z"
          fill="black"
        />
        <path
          d="M43.6221 20.1756C40.5111 26.6535 40.2303 33.8531 42.2856 40.6129C48.8334 38.0195 54.2749 33.3175 57.386 26.8396C60.497 20.3617 60.7778 13.1621 58.7225 6.40234C52.1747 8.99576 46.7331 13.6977 43.6221 20.1756Z"
          fill="#FFA64D"
        />
        <path
          d="M43.6221 20.1766C40.5111 26.6545 40.2303 33.8541 42.2856 40.6139C46.048 39.1255 49.4343 36.938 52.2364 34.1191C53.0339 31.6891 53.4663 29.1408 53.4663 26.5136C53.4663 21.4733 51.8995 16.7206 49.131 12.543C46.9016 14.7079 45.026 17.2619 43.6277 20.1766H43.6221Z"
          fill="#365B27"
        />
        <path
          d="M43.6221 20.1766C40.5111 26.6545 40.2303 33.8541 42.2856 40.6139C46.048 39.1255 49.4343 36.938 52.2364 34.1191C53.0339 31.6891 53.4663 29.1408 53.4663 26.5136C53.4663 21.4733 51.8995 16.7206 49.131 12.543C46.9016 14.7079 45.026 17.2619 43.6277 20.1766H43.6221Z"
          fill="#FEB557"
        />
        <path
          d="M23.8394 55.574C19.6221 54.6494 15.3823 55.4951 11.7266 57.6487C14.1581 61.1386 17.6623 63.6812 21.8796 64.6002C26.0969 65.5192 30.3367 64.6791 33.9925 62.5255C31.5609 59.0356 28.0568 56.493 23.8394 55.574Z"
          fill="#769E4C"
        />
        <path
          d="M23.8394 55.574C19.6221 54.6494 15.3823 55.4951 11.7266 57.6487C14.1581 61.1386 17.6623 63.6812 21.8796 64.6002C26.0969 65.5192 30.3367 64.6791 33.9925 62.5255C31.5609 59.0356 28.0568 56.493 23.8394 55.574Z"
          fill="black"
        />
        <path
          d="M23.8394 55.574C19.6221 54.6494 15.3823 55.4951 11.7266 57.6487C14.1581 61.1386 17.6623 63.6812 21.8796 64.6002C26.0969 65.5192 30.3367 64.6791 33.9925 62.5255C31.5609 59.0356 28.0568 56.493 23.8394 55.574Z"
          fill="#779BF1"
        />
        <path
          d="M23.8385 55.5769C21.7889 55.1259 19.7279 55.0977 17.7344 55.436C18.0152 55.8644 18.3016 56.2873 18.6104 56.6988C21.2217 60.2056 24.5742 62.8723 28.376 64.6764C30.3358 64.2987 32.2339 63.5657 33.9916 62.5284C31.56 59.0385 28.0559 56.4959 23.8385 55.5769Z"
          fill="#365B27"
        />
        <path
          d="M23.8385 55.5769C21.7889 55.1259 19.7279 55.0977 17.7344 55.436C18.0152 55.8644 18.3016 56.2873 18.6104 56.6988C21.2217 60.2056 24.5742 62.8723 28.376 64.6764C30.3358 64.2987 32.2339 63.5657 33.9916 62.5284C31.56 59.0385 28.0559 56.4959 23.8385 55.5769Z"
          fill="#507CED"
        />
        <path
          d="M58.9188 62.4396C54.0669 66.0083 51.0289 71.229 49.8945 77.0473C55.7628 77.7238 61.6368 76.3933 66.4887 72.8245C71.3405 69.2558 74.3786 64.0351 75.5129 58.2168C69.6446 57.5403 63.7707 58.8708 58.9188 62.4396Z"
          fill="#769E4C"
        />
        <path
          d="M58.9188 62.4396C54.0669 66.0083 51.0289 71.229 49.8945 77.0473C55.7628 77.7238 61.6368 76.3933 66.4887 72.8245C71.3405 69.2558 74.3786 64.0351 75.5129 58.2168C69.6446 57.5403 63.7707 58.8708 58.9188 62.4396Z"
          fill="#507CED"
        />
        <path
          d="M58.9185 62.4384C55.2796 65.1107 52.6627 68.719 51.1016 72.8064C56.4308 72.4625 61.4961 70.4723 65.5 66.7344C68.1225 64.2876 70.0374 61.3277 71.2504 58.0859C66.8477 58.3227 62.5911 59.7378 58.9129 62.4384H58.9185Z"
          fill="#365B27"
        />
        <path
          d="M58.9185 62.4384C55.2796 65.1107 52.6627 68.719 51.1016 72.8064C56.4308 72.4625 61.4961 70.4723 65.5 66.7344C68.1225 64.2876 70.0374 61.3277 71.2504 58.0859C66.8477 58.3227 62.5911 59.7378 58.9129 62.4384H58.9185Z"
          fill="#779BF1"
        />
        <path
          d="M48.2779 64.7619C48.0701 62.4729 46.975 60.4602 45.3072 58.9492C43.937 60.7364 43.2182 62.9183 43.4204 65.2073C43.6225 67.4962 44.7232 69.5089 46.391 71.0199C47.7612 69.2327 48.48 67.0508 48.2779 64.7619Z"
          fill="#769E4C"
        />
        <path
          d="M48.2779 64.7619C48.0701 62.4729 46.975 60.4602 45.3072 58.9492C43.937 60.7364 43.2182 62.9183 43.4204 65.2073C43.6225 67.4962 44.7232 69.5089 46.391 71.0199C47.7612 69.2327 48.48 67.0508 48.2779 64.7619Z"
          fill="#507CED"
        />
        <path
          d="M51.1653 52.622C53.4845 51.4268 55.1411 49.4028 56.0284 46.9842C53.5632 46.2907 50.9519 46.4542 48.6327 47.6494C46.3134 48.8447 44.6568 50.8687 43.7695 53.2873C46.2348 53.9808 48.846 53.8173 51.1653 52.622Z"
          fill="#FEB557"
        />
        <path
          d="M51.1653 52.622C53.4845 51.4268 55.1411 49.4028 56.0284 46.9842C53.5632 46.2907 50.9519 46.4542 48.6327 47.6494C46.3134 48.8447 44.6568 50.8687 43.7695 53.2873C46.2348 53.9808 48.846 53.8173 51.1653 52.622Z"
          fill="#FFA64D"
        />
        <path
          d="M31.2227 24.7843C31.2227 33.85 35.2378 42.1771 41.9372 48.717C48.6367 42.1715 52.6518 33.85 52.6518 24.7843C52.6518 15.7186 48.6367 7.39148 41.9372 0.851562C35.2378 7.39712 31.2227 15.7186 31.2227 24.7843Z"
          fill="#769E4C"
        />
        <path
          d="M31.2227 24.7843C31.2227 33.85 35.2378 42.1771 41.9372 48.717C48.6367 42.1715 52.6518 33.85 52.6518 24.7843C52.6518 15.7186 48.6367 7.39148 41.9372 0.851562C35.2378 7.39712 31.2227 15.7186 31.2227 24.7843Z"
          fill="#FEB557"
        />
        <path
          d="M41.9375 0.84375V48.7148C48.6369 42.1693 52.6521 33.8478 52.6521 24.7821C52.6521 15.7164 48.6369 7.38932 41.9375 0.849393V0.84375Z"
          fill="black"
        />
        <path
          d="M41.9375 0.84375V48.7148C48.6369 42.1693 52.6521 33.8478 52.6521 24.7821C52.6521 15.7164 48.6369 7.38932 41.9375 0.849393V0.84375Z"
          fill="#FFA64D"
        />
        <path
          d="M57.763 45.7612C51.9677 51.5795 49.2216 59.512 49.3396 68.0308C57.8248 68.1492 65.7203 65.3923 71.5212 59.574C77.3165 53.7557 80.0626 45.8232 79.9446 37.3044C71.4595 37.186 63.5639 39.943 57.763 45.7612Z"
          fill="#769E4C"
        />
        <path
          d="M57.763 45.7612C51.9677 51.5795 49.2216 59.512 49.3396 68.0308C57.8248 68.1492 65.7203 65.3923 71.5212 59.574C77.3165 53.7557 80.0626 45.8232 79.9446 37.3044C71.4595 37.186 63.5639 39.943 57.763 45.7612Z"
          fill="#507CED"
        />
        <path
          d="M57.763 45.7612C51.9677 51.5795 49.2216 59.512 49.3396 68.0308C57.8248 68.1492 65.7203 65.3923 71.5212 59.574C77.3165 53.7557 80.0626 45.8232 79.9446 37.3044C71.4595 37.186 63.5639 39.943 57.763 45.7612Z"
          fill="#779BF1"
        />
        <path
          d="M57.763 45.7612C51.9677 51.5795 49.2216 59.512 49.3396 68.0308C57.8248 68.1492 65.7203 65.3923 71.5212 59.574C77.3165 53.7557 80.0626 45.8232 79.9446 37.3044C71.4595 37.186 63.5639 39.943 57.763 45.7612Z"
          fill="url(#paint3_linear_8223_80777)"
          fillOpacity="0.8"
        />
        <path
          d="M79.9449 37.3047L49.3398 68.031C57.825 68.1494 65.7206 65.3925 71.5215 59.5742C77.3224 53.756 80.0628 45.8235 79.9449 37.3047Z"
          fill="black"
        />
        <path
          d="M79.9449 37.3047L49.3398 68.031C57.825 68.1494 65.7206 65.3925 71.5215 59.5742C77.3224 53.756 80.0628 45.8235 79.9449 37.3047Z"
          fill="#507CED"
        />
        <path
          d="M79.9449 37.3047L49.3398 68.031C57.825 68.1494 65.7206 65.3925 71.5215 59.5742C77.3224 53.756 80.0628 45.8235 79.9449 37.3047Z"
          fill="url(#paint4_linear_8223_80777)"
          fillOpacity="0.5"
        />
        <path
          d="M9.79212 76.5267C14.6215 79.4583 20.3607 79.994 26.01 78.5112C24.6903 72.7944 21.5512 67.9458 16.7218 65.0142C11.8924 62.0825 6.15321 61.5469 0.503906 63.0296C1.82357 68.7464 4.9627 73.595 9.79212 76.5267Z"
          fill="#769E4C"
        />
        <path
          d="M9.79212 76.5267C14.6215 79.4583 20.3607 79.994 26.01 78.5112C24.6903 72.7944 21.5512 67.9458 16.7218 65.0142C11.8924 62.0825 6.15321 61.5469 0.503906 63.0296C1.82357 68.7464 4.9627 73.595 9.79212 76.5267Z"
          fill="#507CED"
        />
        <path
          d="M0.5 63.0296L26.0061 78.5112C24.6864 72.7944 21.5473 67.9458 16.7179 65.0142C11.8885 62.0825 6.1493 61.5469 0.5 63.0296Z"
          fill="black"
        />
        <path
          d="M0.5 63.0296L26.0061 78.5112C24.6864 72.7944 21.5473 67.9458 16.7179 65.0142C11.8885 62.0825 6.1493 61.5469 0.5 63.0296Z"
          fill="#779BF1"
        />
        <path
          d="M19.665 54.1325C23.7419 59.6576 29.9359 62.9106 36.961 63.8634C38.101 56.8387 36.8038 49.9436 32.7269 44.4185C28.6499 38.8934 22.4559 35.6403 15.4308 34.6875C14.2908 41.7123 15.588 48.6074 19.665 54.1325Z"
          fill="#769E4C"
        />
        <path
          d="M19.665 54.1325C23.7419 59.6576 29.9359 62.9106 36.961 63.8634C38.101 56.8387 36.8038 49.9436 32.7269 44.4185C28.6499 38.8934 22.4559 35.6403 15.4308 34.6875C14.2908 41.7123 15.588 48.6074 19.665 54.1325Z"
          fill="#507CED"
        />
        <path
          d="M19.665 54.1325C23.7419 59.6576 29.9359 62.9106 36.961 63.8634C38.101 56.8387 36.8038 49.9436 32.7269 44.4185C28.6499 38.8934 22.4559 35.6403 15.4308 34.6875C14.2908 41.7123 15.588 48.6074 19.665 54.1325Z"
          fill="url(#paint5_linear_8223_80777)"
          fillOpacity="0.5"
        />
        <path
          d="M15.4258 34.6875L36.9616 63.8634C38.1016 56.8387 36.8044 49.9436 32.7275 44.4185C28.6505 38.8934 22.4565 35.6403 15.4314 34.6875H15.4258Z"
          fill="black"
        />
        <path
          d="M15.4258 34.6875L36.9616 63.8634C38.1016 56.8387 36.8044 49.9436 32.7275 44.4185C28.6505 38.8934 22.4565 35.6403 15.4314 34.6875H15.4258Z"
          fill="#779BF1"
        />
        <path
          d="M15.4258 34.6875L36.9616 63.8634C38.1016 56.8387 36.8044 49.9436 32.7275 44.4185C28.6505 38.8934 22.4565 35.6403 15.4314 34.6875H15.4258Z"
          fill="#FEB557"
        />
        <path
          d="M15.4258 34.6875L36.9616 63.8634C38.1016 56.8387 36.8044 49.9436 32.7275 44.4185C28.6505 38.8934 22.4565 35.6403 15.4314 34.6875H15.4258Z"
          fill="url(#paint6_linear_8223_80777)"
          fillOpacity="0.6"
        />
        <path
          d="M53.9553 31.2387C51.3946 34.441 50.4568 38.5285 50.979 42.7513C55.1964 42.3453 58.97 40.5468 61.5308 37.3445C64.0915 34.1422 65.0293 30.0548 64.507 25.832C60.2897 26.238 56.516 28.0364 53.9553 31.2387Z"
          fill="#769E4C"
        />
        <path
          d="M53.9553 31.2387C51.3946 34.441 50.4568 38.5285 50.979 42.7513C55.1964 42.3453 58.97 40.5468 61.5308 37.3445C64.0915 34.1422 65.0293 30.0548 64.507 25.832C60.2897 26.238 56.516 28.0364 53.9553 31.2387Z"
          fill="#507CED"
        />
        <path
          d="M53.9553 31.2387C51.3946 34.441 50.4568 38.5285 50.979 42.7513C55.1964 42.3453 58.97 40.5468 61.5308 37.3445C64.0915 34.1422 65.0293 30.0548 64.507 25.832C60.2897 26.238 56.516 28.0364 53.9553 31.2387Z"
          fill="#FEB557"
        />
        <path
          d="M64.5007 25.832L50.9727 42.7513C55.19 42.3453 58.9637 40.5468 61.5244 37.3445C64.0851 34.1422 65.0229 30.0548 64.5007 25.832Z"
          fill="black"
        />
        <path
          d="M64.5007 25.832L50.9727 42.7513C55.19 42.3453 58.9637 40.5468 61.5244 37.3445C64.0851 34.1422 65.0229 30.0548 64.5007 25.832Z"
          fill="#FFA64D"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8223_80777"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(41.98 48.9429) rotate(90) scale(47.3228 28.3208)"
          >
            <stop offset="0.217677" stopColor="#FEB558" />
            <stop offset="1" stopColor="#0040FA" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_8223_80777"
            x1="28.0512"
            y1="98.4185"
            x2="52.5929"
            y2="127.64"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3366FB" />
            <stop offset="1" stopColor="#668CFC" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_8223_80777"
            x1="85.0478"
            y1="88.2715"
            x2="54.08"
            y2="55.4472"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3366FB" />
            <stop offset="1" stopColor="#668CFC" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_8223_80777"
            x1="52.4408"
            y1="47.213"
            x2="119.888"
            y2="66.4973"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEB558" />
            <stop offset="1" stopColor="#0040FA" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_8223_80777"
            x1="52.4444"
            y1="47.2158"
            x2="119.884"
            y2="66.4977"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEB558" />
            <stop offset="1" stopColor="#0040FA" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_8223_80777"
            x1="17.2991"
            y1="44.0973"
            x2="68.0521"
            y2="55.2433"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEB558" />
            <stop offset="1" stopColor="#0040FA" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_8223_80777"
            x1="32.4253"
            y1="34.8141"
            x2="8.71827"
            y2="75.8023"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEB558" />
            <stop offset="1" stopColor="#0040FA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default Plant;
